module.exports = __webpack_public_path__ + "static/media/19.08e5726a.png";